export enum InventoryErrorFieldSource {
  InventoryKey = 'inventoryKey',
  Repository = 'repository'
}
